import Vue from "vue"
import hasPermission from './hasPermission'
import formatDate from './formatDate'

Vue.filter("permission", hasPermission);
Vue.filter("formatDate", formatDate);
